import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';
import { StepCardComponent } from './step-card/step-card.component';
import { RegisterPopComponent } from '../../../auth/components/register-pop/register-pop';
import { TranslationService } from '../../../../core/services/translation.service';
import { LanguageService } from '../../../../core/services/language.service';
import { Subscription } from 'rxjs';

export interface StepData {
  id: number;
  title: string;
  description: string;
  icon: string;
  gradientClasses: string;
  bgLightClass: string;
}

@Component({
  selector: 'app-home-how-does-stay-at-work',
  imports: [CommonModule, StepCardComponent, RegisterPopComponent, TranslatePipe],
  templateUrl: './home-how-does-stay-at-work.html',
  styleUrl: './home-how-does-stay-at-work.scss',
  standalone: true,
})
export class HomeHowDoesStayAtWork implements OnInit, OnDestroy {
  showRegisterPopup = false;
  steps: StepData[] = [];
  private subscriptions: Subscription[] = [];

  constructor(
    private translationService: TranslationService,
    private languageService: LanguageService,
  ) {}

  ngOnInit(): void {
    // Wait for translations to load
    const translationSub = this.translationService.translationsLoaded$.subscribe((loaded) => {
      if (loaded) {
        this.loadSteps();
      }
    });
    this.subscriptions.push(translationSub);

    // Subscribe to language changes to reload steps
    const langSub = this.languageService.currentLanguage$.subscribe(() => {
      if (this.translationService.isLoaded()) {
        this.loadSteps();
      }
    });
    this.subscriptions.push(langSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  private loadSteps(): void {
    this.steps = [
      {
        id: 1,
        title: this.translationService.t('home.howItWorks.steps.search.title'),
        description: this.translationService.t('home.howItWorks.steps.search.description'),
        icon: 'fas fa-search',
        gradientClasses: 'bg-info/10 border border-info/20',
        bgLightClass: 'bg-info/5',
      },
      {
        id: 2,
        title: this.translationService.t('home.howItWorks.steps.browse.title'),
        description: this.translationService.t('home.howItWorks.steps.browse.description'),
        icon: 'fas fa-eye',
        gradientClasses: 'bg-surface-elevated border border-border-strong',
        bgLightClass: 'bg-surface/50',
      },
      {
        id: 3,
        title: this.translationService.t('home.howItWorks.steps.book.title'),
        description: this.translationService.t('home.howItWorks.steps.book.description'),
        icon: 'fas fa-check-circle',
        gradientClasses: 'bg-success/10 border border-success/20',
        bgLightClass: 'bg-success/5',
      },
      {
        id: 4,
        title: this.translationService.t('home.howItWorks.steps.move.title'),
        description: this.translationService.t('home.howItWorks.steps.move.description'),
        icon: 'fas fa-key',
        gradientClasses: 'bg-gradient-to-br from-primary to-primary-deep shadow-primary-glow',
        bgLightClass: 'bg-primary/10',
      },
    ];
  }

  onStartJourney(): void {
    this.showRegisterPopup = true;
  }

  closeRegisterPopup(): void {
    this.showRegisterPopup = false;
  }
}
